import cx from 'classnames'
import { Switch as AntdSwitch } from 'antd'
import { SwitchProps as Props } from 'antd/es/switch'
import React from 'react'
import { Typography } from '../AppTypography'
import './styles.scss'

/**
 * This class is a wrap around [antd Switch](https://ant.design/components/switch/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 */

const PrefixCls = 'app-switch'
const { Text } = Typography

export interface SwitchProps extends Props {
  children?: React.ReactNode
  rootClassName?: string
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className, children, size = 'small', rootClassName, ...props }: SwitchProps, ref) => (
    <span className={cx('u-flex-align-center', rootClassName)}>
      <AntdSwitch ref={ref} size={size} className={cx(PrefixCls, className)} {...props} />
      {React.Children.count(children) > 0 && (
        <Text size={size === 'small' ? 'regular' : 'lead'} strong="semi-bold" className="u-margin-left--small-2">
          {children}
        </Text>
      )}
    </span>
  )
)
Switch.displayName = 'Switch'

export default Switch
